

import React from "react";

export const ViolationIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-6 h-6 text-ultramarine-60",
    ...props
}) => {
    return (

        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="flex-shrink-0 mt-0.5">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="#EAB308"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <line x1="12" y1="9" x2="12" y2="13" stroke="#EAB308" strokeWidth="1.5" strokeLinecap="round" />
            <circle cx="12" cy="17" r="0.5" stroke="#EAB308" strokeWidth="1.5" strokeLinecap="round" />
        </svg>

    );
};



